import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Lightbulb, Clock } from 'lucide-react';
import { cn } from '../../utils/cn';
import { useLanguage } from '../../contexts/LanguageContext';

const KeyInsights = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useLanguage();

  return (
    <div className="bg-white rounded-lg border">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-4 py-2.5 flex items-center justify-between hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-2">
          <Lightbulb className="w-4 h-4 text-indigo-600" />
          <span className="text-sm font-medium text-gray-700">{t('dashboard.insights.title')}</span>
        </div>
        {isExpanded ? (
          <ChevronUp className="w-4 h-4 text-gray-400" />
        ) : (
          <ChevronDown className="w-4 h-4 text-gray-400" />
        )}
      </button>

      <div
        className={cn(
          "transition-all duration-200",
          !isExpanded && "hidden"
        )}
      >
        <div className="p-6 flex flex-col items-center justify-center text-center">
          <div className="bg-blue-100 rounded-full p-3 mb-4">
            <Clock className="w-6 h-6 text-blue-600" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            {t('common.language') === 'English' ? 'Coming Soon' : 'Em Breve'}
          </h3>
          <p className="text-sm text-gray-500 max-w-md">
            {t('common.language') === 'English' 
              ? 'AI-powered insights are coming soon to help you make better hiring decisions. Stay tuned for powerful analytics and data-driven recommendations.'
              : 'Insights alimentados por IA estarão disponíveis em breve para ajudar você a tomar melhores decisões de contratação. Fique atento para análises poderosas e recomendações baseadas em dados.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default KeyInsights;